import { useEffect, useState } from "react";
import { message } from "antd";
import { GetApplicationDetail } from "@/services/application.service";
import type { ApplicationItem } from "@/types/Application/application";

export function useApplicationModal() {
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [resultType, setResultType] =
    useState<"accepted" | "rejected" | "deleted" | null>(null);

  const [selectedRow, setSelectedRow] =
    useState<ApplicationItem | null>(null);

  const [detailData, setDetailData] =
    useState<ApplicationItem | null>(null);

  // Auto close result modal after 3 seconds
  useEffect(() => {
    if (!resultModalOpen) return;

    const timer = window.setTimeout(() => {
      setResultModalOpen(false);
      setResultType(null);
    }, 3000);

    return () => window.clearTimeout(timer);
  }, [resultModalOpen]);

  const handleOpenModal = async (row: ApplicationItem) => {
    setSelectedRow(row);
    setDetailData(null);

    try {
      const response = await GetApplicationDetail({
        registrationId: row.registrationId,
        reason: "",
      });

      setDetailData(response.data);
      setIsDetailModalOpen(true);
    } catch (error) {
      message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan maklumat permohonan",
      );

      setIsDetailModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsDetailModalOpen(false);
  };

  const handleOpenEditModal = () => {
    if (!selectedRow) return;

    setIsDetailModalOpen(false);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleOpenDeleteModal = () => {
    setIsEditModalOpen(false);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleBackFromDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setIsEditModalOpen(true);
  };

  const handleBackToDetailModal = () => {
    setIsEditModalOpen(false);
    setIsDetailModalOpen(true);
  };

  const handleOpenAcceptModal = () => {
    setIsDetailModalOpen(false);
    setIsAcceptModalOpen(true);
  };

  const handleCloseAcceptModal = () => {
    setIsAcceptModalOpen(false);
  };

  const handleBackFromAcceptModal = () => {
    setIsAcceptModalOpen(false);
    setIsDetailModalOpen(true);
  };

  const handleOpenRejectModal = () => {
    setIsDetailModalOpen(false);
    setIsRejectModalOpen(true);
  };

  const handleCloseRejectModal = () => {
    setIsRejectModalOpen(false);
  };

  const handleBackFromRejectModal = () => {
    setIsRejectModalOpen(false);
    setIsDetailModalOpen(true);
  };

  const handleAcceptSuccess = () => {
    setIsAcceptModalOpen(false);
    setResultType("accepted");
    setResultModalOpen(true);
  };

  const handleRejectSuccess = () => {
    setIsRejectModalOpen(false);
    setResultType("rejected");
    setResultModalOpen(true);
  };

  const handleDeleteSuccess = () => {
    setIsDeleteModalOpen(false);
    setResultType("deleted");
    setResultModalOpen(true);
  };

  const handleCloseResultModal = () => {
    setResultModalOpen(false);
    setResultType(null);
  };

  return {
    selectedRow,
    setSelectedRow,
    detailData,
    resultType,

    isDetailModalOpen,
    isEditModalOpen,
    isDeleteModalOpen,
    isAcceptModalOpen,
    isRejectModalOpen,
    resultModalOpen,

    handleOpenModal,
    handleCloseModal,

    handleOpenEditModal,
    handleCloseEditModal,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleBackFromDeleteModal,
    handleDeleteSuccess,
    handleBackToDetailModal,

    handleOpenAcceptModal,
    handleCloseAcceptModal,
    handleBackFromAcceptModal,
    handleAcceptSuccess,

    handleOpenRejectModal,
    handleCloseRejectModal,
    handleBackFromRejectModal,
    handleRejectSuccess,

    handleCloseResultModal,
  };
}